/* eslint-disable import/prefer-default-export */

// given a locale, return the thousands-separator string for it or '' if the
// locale does not use a thousands-separator
export const getThousandsSeparator = (locale) => {
  if (typeof Intl !== 'object') {
    return ','; // fallback
  }
  const numFormat = new Intl.NumberFormat(locale);
  const parts = numFormat.formatToParts(1000000);
  const sep = parts.find((p) => p.type === 'group');
  return sep?.value || '';
};
